export default {
  types: [],
  views: [],
  activities: [],
  glAccounts: [],
  slAccounts: [],
  slTaxEntries: [],
  isFetchingInitialDataForAddAndEditModal: false,
};
